//import react from "react";
import { ModalStatus, OverlayBackdrop } from "@ds/ds-snam/react";
import { useTranslation } from "react-i18next";

interface IConfirmPopUpProps{
    title:string,
    description:string,
    onClose:()=>void,
    onConfirm:()=>void
}
const ConfirmPopUp: React.FC<IConfirmPopUpProps> = (props): JSX.Element => {
    const {t} = useTranslation(['app']);
    const {title, description, onClose, onConfirm} = props;

    return <div style={{ zIndex: 1200, position: "relative" }}>
        <OverlayBackdrop/>
        <ModalStatus
            notification-status="warning"
            popup-size="medium"
            popup-title={title}
            popup-description={description}
            primary-button-label={t('general.buttons.confirm')}//"Conferma"
            secondary-button-label={t('general.buttons.cancel')}//"Annulla"
            horizontal-position="center"
            vertical-position="middle"
            primary-button-aria-label="confirm popup"
            secondary-button-aria-label="cancel popup"
            popup-title-id="titolo_popup"
            popup-description-id="descrizione_popup"
            onClosePopup={onClose}
            onConfirmPopup={onConfirm}
        ></ModalStatus></div>
}

export default ConfirmPopUp;